export default "__VITE_ASSET__CyNO5Oav__"